import { useState } from "react";
import { RANKING_TABS, RANKINGS } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";

export default function Ranking() {
  const [tab, setTab] = useState<string>(RANKING_TABS[0]);
  const list = RANKINGS[tab as keyof typeof RANKINGS];

  return (
    <section id="rank" className="relative scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-end">
            <SectionHeading
              align="left"
              kicker="吃瓜热榜"
              title={
                <>
                  实时热度 <span className="text-primary-600">前排坐好</span>
                </>
              }
              desc="热搜瓜、口碑局实时刷新，热度榜单一目了然，跟着大部队永远不吃过期瓜。"
            />
            <div className="flex rounded-full bg-secondary-100 p-1">
              {RANKING_TABS.map((t) => (
                <button
                  key={t}
                  type="button"
                  onClick={() => setTab(t)}
                  className={`rounded-full px-5 py-2 text-sm font-semibold transition whitespace-nowrap ${
                    tab === t ? "bg-primary-500 text-foreground-950" : "text-foreground-600 hover:text-foreground-950"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-10 overflow-hidden rounded-3xl border border-background-200 bg-background-100">
            {list.map((item, idx) => {
              const top = item.rank <= 3;
              return (
                <div
                  key={`${tab}-${item.rank}`}
                  className={`flex flex-col gap-3 px-4 py-4 transition hover:bg-background-50 sm:flex-row sm:items-center sm:gap-6 sm:px-6 ${
                    idx !== list.length - 1 ? "border-b border-background-200" : ""
                  }`}
                >
                  <div className="flex items-center gap-4 sm:w-16">
                    <span
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl text-base font-bold ${
                        item.rank === 1
                          ? "bg-accent-500 text-foreground-950"
                          : item.rank === 2
                          ? "bg-primary-300 text-foreground-950"
                          : item.rank === 3
                          ? "bg-secondary-600 text-background-50"
                          : "bg-secondary-100 text-foreground-600"
                      }`}
                    >
                      {item.rank}
                    </span>
                  </div>

                  <div className="flex flex-1 flex-col gap-1.5 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="truncate text-sm md:text-base font-semibold text-foreground-950">
                        {item.topic}
                      </span>
                      {top && (
                        <span className="hidden sm:inline-flex shrink-0 items-center gap-1 rounded-full bg-accent-100 px-2 py-0.5 text-xs font-semibold text-accent-800">
                          <i className="ri-fire-fill" /> 热门
                        </span>
                      )}
                    </div>
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-user-heart-line text-primary-600" /> {item.host}
                      </span>
                      <span className="rounded bg-secondary-100 px-2 py-0.5 text-foreground-700">{item.tag}</span>
                      <span
                        className={`inline-flex items-center gap-0.5 ${
                          item.trend === "up" ? "text-primary-600" : "text-secondary-600"
                        }`}
                      >
                        <i className={item.trend === "up" ? "ri-arrow-up-line" : "ri-arrow-down-line"} />
                        {item.trend === "up" ? "热度上升" : "热度回落"}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 sm:w-52">
                    <div className="h-2 flex-1 overflow-hidden rounded-full bg-secondary-200">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                        style={{ width: `${item.heat}%` }}
                      ></div>
                    </div>
                    <span className="w-14 text-right text-sm font-bold text-foreground-800">
                      {item.heat.toFixed(1)}w
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}